import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Tab,
  Breadcrumbs,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import BasicInformationTab from "./BasicInformationTab";
import GrossIncomeTab from "./GrossIncomeTab";
import AdjustedIncomeTab from "./AdjustedIncomeTab";
import ScheduleCTab from "./ScheduleCTab";
import HealthInsuranceTab from "./HealthInsuranceTab";
import DeviationsTab from "./DeviationsTab";
import SelfEmploymentTab from "./SelfEmploymentTab";
import FootnotesTab from "./FootnotesTab";
import { useMediaQuery, useTheme } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../globalState/hooks";
import { updateBasicInfo } from "../../globalState/actions/create-worksheet-action";
// import { headerActiveLink } from "../../globalState/actions/headerAction";
// import { useSelector } from "react-redux";
// import { HeaderActiveState } from "../../utils/userDetailsCommonType";
import { useTranslation } from "react-i18next";
import { headerActiveLink } from "../../globalState/actions/headerAction";

const CreateWorkSheet: React.FC = () => {
  const states = useAppSelector((state) => state.createWorksheet);
  // const activeUrl = useSelector(
  //   (state: HeaderActiveState) => state.headerURLData.headerActiveURL
  // );
  const activeUrl = window.location.pathname;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const theme = useTheme();

  const handleChange = (event: React.SyntheticEvent, value: string) => {
    (dispatch as any)(updateBasicInfo("activeTab", value));
  };
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const { t } = useTranslation();

  /// handle Home Page redirection code
  const handleHomeRedirection = () => {
    dispatch(headerActiveLink(""));
    navigate("/");
  };

  const CurrentPageName =
    activeUrl === "/WorkSheets/createWorksheet"
      ? t("Create Folder/Worksheet")
      : t("Update Folder/Worksheet");

  return (
    <>
      <Box
        className="contain__area"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          mt={{ xs: 1, sm: 1, md: 4 }}
          sx={{
            display: "flex",
            textAlign: "left",
            width: { md: "90%", sm: "90%", xs: "100%" },
          }}
        >
          <div role="presentation">
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                to="/"
                className="LinkColorBlue"
                onClick={handleHomeRedirection}
              >
                {t("Home")}
              </Link>
              <Link to="/SearchFolderWorksheet" className="LinkColorDark">
                {t("Search Folders-Worksheets")}
              </Link>

              <Typography color="text.primary">{CurrentPageName}</Typography>
            </Breadcrumbs>
          </div>
        </Box>

        {/*--------- Update title--- */}
        {activeUrl !== "/WorkSheets/createWorksheet" && (
          <Box
            mt={{ xs: 1, sm: 1, md: 1 }}
            sx={{
              textAlign: "left",
              width: { md: "90%", sm: "90%", xs: "100%" },
            }}
          >
            <Typography
              className="h4 main_heading"
              fontSize={22}
              sx={{
                color: "#0464AB",
                paddingTop: "10px",
              }}
            >
              {t("Update Child Support Case:")}{" "}
              {states.plaintiff_name + " v. " + states.defendant_name}
            </Typography>
            <Typography sx={{}}>
              {t("Worksheet Description:")} {states.description}
            </Typography>
            <Typography sx={{}}>
              {t("Worksheet Id:")} {states.worksheet_id}
            </Typography>
          </Box>
        )}

        <Card
          sx={{
            width: {
              xs: "100%",
              sm: "90%",
            },
            borderRadius: "5px",
            border: "1px solid #DFDFDF",
            marginTop: "15px",
          }}
        >
          <CardContent sx={{ padding: "0px!important" }}>
            <Typography
              className="h4 main_heading"
              fontSize={22}
              sx={{
                color: "#0464AB",
                paddingX: "16px",
                paddingTop: "16px",
              }}
            >
              {CurrentPageName}
            </Typography>
            <TabContext value={states.activeTab ?? ""}>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "#404040",
                  background: "#404040",
                  width: "100%",
                  overflowX: "auto",
                  marginTop: {
                    xs: "10px",
                    sm: "15px",
                    md: "15px",
                  },
                }}
              >
                <TabList
                  onChange={handleChange}
                  aria-label="Worksheet"
                  variant={isMobile ? "scrollable" : "fullWidth"}
                  sx={{
                    "& .MuiTabs-flexContainer": {
                      flexDirection: isMobile ? "row" : "row",
                      justifyContent: isMobile ? "flex-start" : "center",
                    },
                  }}
                  TabIndicatorProps={{
                    style: {
                      backgroundColor: "#F5B325",
                      border: "1px solid #F5B325",
                    },
                  }}
                >
                  {[
                    { label: t("Basic Information Worksheet"), value: "1" },
                    { label: t("Gross Income Schedule A"), value: "2" },
                    { label: t("Adjusted Income Schedule B"), value: "3" },
                    { label: t("Parenting Time Schedule C"), value: "4" },
                    {
                      label: t("Health Insurance/Child Care Schedule D"),
                      value: "5",
                    },
                    { label: t("Deviations Schedule E"), value: "6" },
                    { label: t("Self-Employment Calculator"), value: "7" },
                    { label: t("Footnotes"), value: "8" },
                  ].map((tab, index, array) => (
                    <Tab
                      key={tab.value}
                      label={tab.label}
                      value={tab.value}
                      sx={{
                        fontSize: {
                          xs: "12px",
                          sm: "12px",
                          md: "12px",
                        },
                        color: "#CECECE",
                        textTransform: "capitalize",
                        height: {
                          xs: "40px",
                          sm: "40px",
                          md: "60px",
                          lg: "55px",
                          xl: "70px",
                        },
                        padding: "10px 15px",
                        minWidth: "100px",
                        maxWidth: "170px",
                        ...(index !== array.length - 1 && {
                          borderRight: "1px solid #CECECE",
                        }),
                        "&.Mui-selected": {
                          color: "#FFF",
                          backgroundColor: "#0464AB",
                        },
                        "&:hover": {
                          backgroundColor: "#0464AB",
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            bottom: 0,
                            width: "100%",
                            height: "2px",
                            backgroundColor: "#F5B325",
                            transform: "scaleX(1)",
                            transition: "transform 1s",
                            transformOrigin: "left",
                            border: "1px solid #F5B325",
                          },
                        },
                        "&::after": {
                          content: '""',
                          position: "absolute",
                          left: 0,
                          bottom: 0,
                          width: "100%",
                          height: "2px",
                          backgroundColor: "#F5B325",
                          transform: "scaleX(0)",
                          transition: "transform 1s",
                          transformOrigin: "left",
                          border: "1px solid #F5B325",
                        },
                        position: "relative",
                      }}
                    />
                  ))}
                </TabList>
              </Box>
              <TabPanel value="1" sx={{ paddingBottom: 0, paddingX: 2 }}>
                <BasicInformationTab />
              </TabPanel>
              <TabPanel value="2" sx={{ paddingBottom: 0, paddingX: 2 }}>
                <GrossIncomeTab />
              </TabPanel>
              <TabPanel value="3" sx={{ paddingBottom: 0, paddingX: 2 }}>
                <AdjustedIncomeTab />
              </TabPanel>
              <TabPanel value="4" sx={{ paddingBottom: 0, paddingX: 2 }}>
                <ScheduleCTab />
              </TabPanel>
              <TabPanel value="5" sx={{ paddingBottom: 0, paddingX: 2 }}>
                <HealthInsuranceTab />
              </TabPanel>
              <TabPanel value="6" sx={{ paddingBottom: 0, paddingX: 2 }}>
                <DeviationsTab />
              </TabPanel>
              <TabPanel value="7" sx={{ paddingBottom: 0, paddingX: 2 }}>
                <SelfEmploymentTab />
              </TabPanel>
              <TabPanel value="8" sx={{ paddingBottom: 0, paddingX: 2 }}>
                <FootnotesTab />
              </TabPanel>
            </TabContext>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default CreateWorkSheet;
